import React, {useState} from 'react';

import {hooks} from '../hooks';
import {Routes} from '../routes';
import {svg} from '../assets/svg';
import {ArticlesType} from '../types';
import {components} from '../components';
import {actions} from '../store/actions';
import { items } from '../items';

export const DetailArticles: React.FC = () => {
  const navigate = hooks.useNavigate();
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();

  const article: ArticlesType = location.state.article;

  const {articlesLoading, articles} = hooks.useGetArticles();

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        showBasket={true}
        title='Article'
      />
    );
  };

  const renderImage = (): JSX.Element => {
    return (
      <section style={{position: 'relative', marginBottom: 15}}>
        <img
          src={article.banner}
          alt={article.title}
          style={{
            width: '100%',
            height: 'auto',
            borderRadius: 6,
          }}
        />
      </section>
    );
  };

  const renderShare = (): JSX.Element => {
    return (
      <section>
        <div className='row-center-space-between' style={{ marginBottom: 15 }}>
          <span className='t12'>{article.date}</span>
          <ul style={{ listStyle: 'none', padding: 0, display: 'flex', gap: 10 }}>
            <li>
              <button
                onClick={() => navigator.share({ title: article.title, url: window.location.href })}
              >
                <svg.FbShareSvg />
              </button>
            </li>
            <li>
              <button
                onClick={() => navigator.share({ title: article.title, url: window.location.href })}
              >
                <svg.InstaSvg />
              </button>
            </li>
          </ul>
        </div>
      </section>
    );
  };

  const renderDetails = (): JSX.Element => {
    return (
      <section>
        <div
          className='row-center-space-between'
        >
          <h3
            style={{textTransform: 'capitalize', marginBottom: 15}}
          >
            {article.title}
          </h3>
        </div>
        {renderImage()}
        {renderShare()}
        <p className='t14' style={{marginTop: 5}}>{article.description}</p>
      </section>
    );
  };

  // const renderOtherArticles = (): JSX.Element => {
  //   if (
  //         articlesLoading ||
  //         articles.length === 0
  //       ) {
  //         return <></>; 
  //       }
    
  //       return (
  //         <section style={{ marginTop: 20, marginBottom: 30 }}>
  //           <h4 style={{ marginBottom: 15 }}>Other Articles</h4>
  //           {articles.map(
  //             (article: ArticlesType, index: number, array: ArticlesType[]) => {
  //               const isLast = index === array.length - 1;

  //               return (
  //                 <div
  //                   style={{
  //                     padding: 14,
  //                     paddingTop: 14,
  //                     paddingBottom: 14,
  //                     borderRadius: 10,
  //                     position: 'relative',
  //                     marginBottom: 14,
  //                     backgroundColor: 'var(--white-color)',
  //                     display: 'block',
  //                     maxWidth: '100%',
  //                     height: 165,
  //                     maxHeight: 165,
  //                   }}
  //                 >
  //                 <items.ArticlesItem
  //                   article={article}
  //                   index={index}
  //                   key={article.id}
  //                   isLast={isLast}
  //                 />
  //               </div>
  //             );
  //           },
  //         )}
  //         </section>
  //       );
  // };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable container' style={{paddingTop: 10, paddingBottom: 20}}>
        {renderDetails()}
        {/* {renderOtherArticles()} */}
      </main>
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
